import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { ReviewPaymentComponent } from './review-payment.component';

export const ngxReviewPaymentModule = angular.module('ngxReviewPaymentModule', [])
	.directive('ngxReviewPayment', downgradeComponent({ component: ReviewPaymentComponent }))
	.name;
